import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTUserVirtualTipz from "../page/VTUserVirtualTipz";

/**
 * Shows User VirtualTipz at venues
 * @returns {JSX.Element}
 * @constructor
 */
export default function LandingUserVirtualTipz() {
    return (
        <>
            <Header headerType="UserOnly"/>
            <VTUserVirtualTipz/>
            <Footer/>
        </>
    );
}